export const SEARCH_CONTENT_CACHE_KEY_NAME = 'search-cache-key';
export const SEARCH_CONTENT_AUTOCOMPLETE_CACHE_KEY_NAME =
  'search-autocomplete-cache-key';
